/**
 * Sample form data for auto-fill on Promotion Rule create page.
 * Only fills requiredYears, description, isActive — from/to position must be selected by user.
 */
export type PromotionRuleFormSample = {
    requiredYears: number;
    description: string;
    isActive: boolean;
};

export const promotionRuleFormSamples: PromotionRuleFormSample[] = [
    {
        requiredYears: 2,
        description: 'ຈາກ Staff ໄປ Senior ຕ້ອງມີປະສົບການຢ່າງໜ້ອຍ 2 ປີ.',
        isActive: true,
    },
    {
        requiredYears: 3,
        description: 'ຈາກ Senior ໄປ Lead ຕ້ອງມີປະສົບການຢ່າງໜ້ອຍ 3 ປີ ໃນຕຳແໜ່ງປັດຈຸບັນ.',
        isActive: true,
    },
    {
        requiredYears: 1,
        description: 'ເສັ້ນທາງເລື່ອນຂັ້ນສຳລັບພະນັກງານໃໝ່ ຫຼັງທົດສອບວຽກ 1 ປີ.',
        isActive: true,
    },
    {
        requiredYears: 5,
        description: 'ຈາກ Manager ໄປ Director ຕ້ອງມີປະສົບການຄຸ້ມຄອງຢ່າງໜ້ອຍ 5 ປີ.',
        isActive: true,
    },
    {
        requiredYears: 0,
        description: 'ເສັ້ນທາງພິເສດ ບໍ່ກຳນົດຈຳນວນປີ ຕາມການອະນຸມັດ.',
        isActive: false,
    },
];
